module.exports = __webpack_public_path__ + "static/media/registration.fbbd1542.jpg";